import { useQuery } from '@tanstack/react-query';
import { PlayerRollCompetitionAwardsQueryKeys } from '../../queryKey';
import { GenericError } from '@/models/generic-error';
import { AxiosError } from 'axios';
import { fetchPlayerRollCompetitionAwards } from './service';
import { useState } from 'react';
import { PaginatedRequest, PaginatedResponse } from '@starsoft/common/models';
import { UsePlayerRollCompetitionAwardsQueryKey } from './props';
import { usePaginatedQuery } from '@starsoft/common/hooks';
import { PlayerRollCompetitionAwardWithRolled } from '@/models/roll-competition/awards';

export function usePlayerRollCompetitionAwards() {
  const [page, setPage] = useState<number>(1);

  const filter: PaginatedRequest = {
    page,
    limit: 10,
  };

  const queryKey: UsePlayerRollCompetitionAwardsQueryKey = [
    PlayerRollCompetitionAwardsQueryKeys.Primary,
    filter,
  ];

  const { isPending, fetchStatus, data, error, refetch, isFetching } = useQuery<
    PaginatedResponse<PlayerRollCompetitionAwardWithRolled>,
    AxiosError<GenericError>,
    PaginatedResponse<PlayerRollCompetitionAwardWithRolled>,
    UsePlayerRollCompetitionAwardsQueryKey
  >({
    queryKey,
    queryFn: fetchPlayerRollCompetitionAwards,
    staleTime: 5 * 1000,
  });

  const paginatedQueryCallbacks = usePaginatedQuery({
    data,
    page,
    setPage,
  });

  return {
    isPending: isPending && fetchStatus !== 'idle',
    playerRollCompetitionAwards: data,
    error,
    refetch,
    isFetching,
    ...paginatedQueryCallbacks,
    page,
  };
}
